export default __webpack_public_path__ + "img/rewards-history-icon-76a9a8ef3d5b6bfb6de1d1131165e387.png";